import { Link } from 'react-router-dom';
import { KeyRound } from 'lucide-react';
import { PATHS } from '@shared/router/paths';

/**
 * identity-service publishes no self-service password recovery route — the
 * only reset is the administrator's `POST /employees/:employeeId/reset-password`
 * (`provisioning.manage`), which returns a temporary password. This page says
 * so instead of pretending to send an email. (Backend gap, documented.)
 */
export function ForgotPasswordPage() {
  return (
    <div className="text-center">
      <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-primary/10 text-primary">
        <KeyRound className="size-5" />
      </div>
      <h2 className="mt-4 text-xl font-semibold">Forgot your password?</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Ask your HR administrator to reset it. They will give you a temporary password; change it
        after you sign in.
      </p>
      <Link
        to={PATHS.auth.login}
        className="mt-6 inline-block text-sm font-medium text-primary hover:underline"
      >
        Back to sign in
      </Link>
    </div>
  );
}
